import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../screen/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_SCREEN_API_URL);

export const stringifyParams = params => qs.stringify(params, { encodeValuesOnly: true });

// Field
export const getFieldList = params => { return apiClient.get(`${url.GET_FIELDS}?${stringifyParams(params)}`); };
export const getField = data => apiClient.get(`${url.FIELD}/${encodeURIComponent(data.field_id)}${data.query ? '?' : ''}${data.query ? stringifyParams(data.query) : ''}`);
export const addNewField = field => apiClient.post(url.ADD_FIELD, field);
export const updateField = field => apiClient.put(url.UPDATE_FIELD + '/' + field._id, field);
export const deleteField = field => apiClient.delete(url.DELETE_FIELD + '/' + field._id);
export const getUserCollections = () => apiClient.get(url.GET_USER_COLLECTIONS);

// Field Item
export const getFieldItemList = () => apiClient.get(url.GET_FIELD_ITEMS);
export const getFieldItem = fieldItem => apiClient.get(url.FIELD_ITEM + '/' + encodeURIComponent(fieldItem));
export const addNewFieldItem = fieldItem => apiClient.post(url.ADD_FIELD_ITEM, fieldItem);
export const updateFieldItem = fieldItem => apiClient.put(url.UPDATE_FIELD_ITEM + '/' + fieldItem._id, fieldItem);
export const deleteFieldItem = fieldItem => apiClient.delete(url.DELETE_FIELD_ITEM + '/' + fieldItem._id);

// Field Type
export const getFieldTypeList = () => apiClient.get(url.GET_FIELD_TYPES);
export const getFieldType = fieldType => apiClient.get(url.FIELD_TYPE + '/' + encodeURIComponent(fieldType));
export const addNewFieldType = fieldType => apiClient.post(url.ADD_FIELD_TYPE, fieldType);
export const updateFieldType = fieldType => apiClient.put(url.UPDATE_FIELD_TYPE + '/' + fieldType._id, fieldType);
export const deleteFieldType = fieldType => apiClient.delete(url.DELETE_FIELD_TYPE + '/' + fieldType._id);

// Screen
export const getScreenList = () => apiClient.get(url.GET_SCREENS);
export const getScreen = screen => apiClient.get(url.SCREEN + '/' + encodeURIComponent(screen));
export const addNewScreen = screen => apiClient.post(url.ADD_SCREEN, screen);
export const updateScreen = screen => apiClient.put(url.UPDATE_SCREEN + '/' + screen._id, screen);
export const deleteScreen = screen => apiClient.delete(url.DELETE_SCREEN + '/' + screen._id);

// Screen Field
export const getScreenFieldList = () => apiClient.get(url.GET_SCREEN_FIELDS);
export const getScreenField = screenField => apiClient.get(url.SCREEN_FIELD + '/' + encodeURIComponent(screenField));
export const addNewScreenField = screenField => apiClient.post(url.ADD_SCREEN_FIELD, screenField);
export const updateScreenField = screenField => apiClient.put(url.UPDATE_SCREEN_FIELD + '/' + screenField._id, screenField);
export const deleteScreenField = screenField => apiClient.delete(url.DELETE_SCREEN_FIELD + '/' + screenField._id);

// PageType
export const getPageList = () => apiClient.get(url.GET_PAGE);
export const getPage = page => apiClient.get(url.PAGE + '/' + encodeURIComponent(page));
export const addNewPage = page => apiClient.post(url.ADD_PAGE, page);
export const updatePage = page => apiClient.put(url.UPDATE_PAGE + '/' + page._id, page);
export const deletePage = page => apiClient.delete(url.DELETE_PAGE + '/' + page._id);

// Page Type
export const getPageTypeList = () => apiClient.get(url.GET_PAGE_TYPE);
export const getPageType = page_type => apiClient.get(url.PAGE_TYPE + '/' + encodeURIComponent(page_type));
export const addNewPageType = page_type => apiClient.post(url.ADD_PAGE_TYPE, page_type);
export const updatePageType = page_type => apiClient.put(url.UPDATE_PAGE_TYPE + '/' + page_type._id, page_type);
export const deletePageType = page_type => apiClient.delete(url.DELETE_PAGE_TYPE + '/' + page_type._id);

// Graph
export const getGraphList = () => apiClient.get(url.GET_GRAPH);
export const getGraph = graph => apiClient.get(url.GRAPH + '/' + encodeURIComponent(graph));
export const addNewGraph = graph => apiClient.post(url.ADD_GRAPH, graph);
export const updateGraph = graph => apiClient.put(url.UPDATE_GRAPH + '/' + graph._id, graph);
export const deleteGraph = graph => apiClient.delete(url.DELETE_GRAPH + '/' + graph._id);

// Report
export const getReportList = () => apiClient.get(url.GET_REPORTS);
export const getReport = report => apiClient.get(url.REPORTS + '/' + encodeURIComponent(report));
export const addNewReport = report => apiClient.post(url.ADD_REPORTS, report);
export const updateReport = report => apiClient.put(url.UPDATE_REPORTS + '/' + report._id, report);
export const deleteReport = report => apiClient.delete(url.DELETE_REPORTS + '/' + report._id);

// Report Template
export const getReportTemplateList = () => apiClient.get(url.GET_REPORT_TEMPLATE);
export const getReportTemplate = report_template => apiClient.get(url.REPORT_TEMPLATE + '/' + encodeURIComponent(report_template));
export const addNewReportTemplate = report_template => apiClient.post(url.ADD_REPORT_TEMPLATE, report_template);
export const updateReportTemplate = report_template => apiClient.put(url.UPDATE_REPORT_TEMPLATE + '/' + report_template._id, report_template);
export const deleteReportTemplate = report_template => apiClient.delete(url.DELETE_REPORT_TEMPLATE + '/' + report_template._id);
